import styled from "@emotion/styled";
import {
  Icon,
  Switch,
  Typography,
  Theme,
  useTheme,
  IconTooltip,
} from "@yuno/design-system-web";
import { useState } from "react";

const Container = styled("div")(({ theme }: { theme?: Theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  padding: "16px",
  paddingRight: "0px",
  marginBottom: "25px",
  border: `1px solid ${theme.palette.grey[2]}`,
  borderRadius: "16px",
  background: `${theme.palette.neutral.white[0]}`,

  "& img": {
    width: "40px",
    height: "40px",
    marginLeft: "16px",
    marginRight: "16px",
  },

  "& p": {
    marginRight: "10px",
  },
}));

const Content = styled.div({ display: "flex", flex: 1, alignItems: "center" });

const emptyImageURL = "https://icons.y.uno/emptystate_logosimbolo.png";

export const DraggableItem = ({
  item,
  onSwitch = null,
  locked = false,
  id = "",
}) => {
  const theme: Theme = useTheme();

  const [error, setError] = useState(false);

  const handleImageError = () => {
    setError(true);
  };

  if (!item) return null;

  return (
    <Container id={id}>
      <Icon
        name={!locked ? "DotsSixVertical" : "Lock"}
        size="24px"
        color={theme.palette.grey[5]}
      />
      <img
        src={error ? emptyImageURL : item?.icon}
        onError={handleImageError}
      />
      <Content>
        <Typography>{item.short_name || item.name}</Typography>
        {item.short_name && (
          <IconTooltip
            name="Info"
            tooltip={{
              children: item.name,
              arrow: true,
              title: item.name,
            }}
            color={theme.palette.grey[5]}
            colorHoverIcon={theme.palette.vivid.brand}
          />
        )}
      </Content>
      {onSwitch && (
        <Switch defaultChecked={item.is_active} onChange={onSwitch} />
      )}
    </Container>
  );
};
